import React from 'react'
import { PaginationProps } from './Types'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
const PaginationComponent: React.FC<PaginationProps> = ({
  hasNext,
  hasPrev,
  onNext,
  onPrev,
}) => {
  return (
    <div
      style={{
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
      }}
    >
      <button
        onClick={onPrev}
        disabled={!hasPrev}
        style={{
          padding: '10px 20px',
          borderRadius: '8px',
          fontWeight: 500,
          border: '1px solid #374151',
          backgroundColor: '#1f2937',
          color: '#f9fafb',
          transition: 'all 0.3s ease',
          cursor: hasPrev ? 'pointer' : 'not-allowed',
          opacity: hasPrev ? 1 : 0.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
        }}
        onMouseOver={(e) => {
          if (hasPrev) e.currentTarget.style.backgroundColor = '#374151'
        }}
        onMouseOut={(e) => {
          if (hasPrev) e.currentTarget.style.backgroundColor = '#1f2937'
        }}
      >
        {/* ⬅️ Previous */}
        <ArrowBackIcon /> Previous
      </button>
      <button
        onClick={onNext}
        disabled={!hasNext}
        style={{
          padding: '10px 20px',
          borderRadius: '8px',
          fontWeight: 500,
          border: '1px solid #374151',
          backgroundColor: '#1f2937',
          color: '#f9fafb',
          transition: 'all 0.3s ease',
          cursor: hasNext ? 'pointer' : 'not-allowed',
          opacity: hasNext ? 1 : 0.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
        }}
        onMouseOver={(e) => {
          if (hasNext) e.currentTarget.style.backgroundColor = '#1d4ed8'
        }}
        onMouseOut={(e) => {
          if (hasNext) e.currentTarget.style.backgroundColor = '#2563eb'
        }}
      >
        {/* Next ➡️ */}
        Next <ArrowForwardIcon />
      </button>
    </div>
  )
}

export default PaginationComponent
